import Deluxe from './Deluxe';

export default Deluxe;